module.exports = __webpack_public_path__ + "static/img/10008 (2).c32494c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10008 (2).webp
// module id = 6RHg
// module chunks = 14